/*
 *###############################################################################
 *Module Name                   : VoucherGRN.js                     #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Friday, October 12th 2021, 3:20:00 pm          #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useState, useEffect } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, Col, Container, Row, CardBody } from "reactstrap"

//**Importing required componant files   */
import Breadcrumb from "components/Common/Breadcrumb"
import DPTopToolBar from "framework/widgets/DPTopToolBar"
import VoucherGRNContent from "./VoucherGRNContent"
import DPInfoBox from "framework/layout/DPInfoBox"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import { setVoucherSave, getVoucherGRNHeader, getVoucherPendingPOHeader } from "./VoucherGRNController"
//*Detail content */
import VoucherGRNDetails from "./VoucherGRNDetails"
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from "react"
import DPPrintOption from "framework/widgets/DPPrintOptions"
//**End Importing required componant files */

const VoucherGRN = props => {
  //*** User input related states */
  let today = new Date()
  let date = today.toISOString().split("T")[0]

  var time = process.env.REACT_APP_ALERTTIMEOUT

  let history = useHistory();
  const {
    getMenuDetails, masterAuditLog, addtoFavourite
  } = useContext(Context);
  const [strVoucherCode, SetCode] = useState("") // Set Code
  const [blVoucherCodeEnable, SetVoucherCodeEnable] = useState(false)
  const [strVoucherDate, SetVoucherDate] = useState(date) //Set DATE
  const [blVoucherDateEnable, SetVoucherDateEnable] = useState(false)
  const [strSupplier, SetSupplier] = useState("")
  const [blSupplierEnable, SetSupplierEnable] = useState(false)
  const [strLocation, SetLocation] = useState("")
  const [blLocationEnable, SetLocationEnable] = useState(false)
  const [strRemarks1, SetRemarks1] = useState("")
  const [blRemarks1Enable, SetRemarks1Enable] = useState(false)
  const [strRemarks2, SetRemarks2] = useState("")
  const [blRemarks2Enable, SetRemarks2Enable] = useState(false)
  const [strRefNo, SetRefNo] = useState("")
  const [blRefNoEnable, SetRefNoEnable] = useState(false)
  const [blmainSearchEnable, SetmainSearchEnable] = useState(false)
  const [strBatchNo, SetBatchNo] = useState("")
  const [blBatchNoEnable, SetBatchNoEnable] = useState(false)
  const [disableRefNo, SetDisableRefNo] = useState(false)

  const [addNew, SetAddNew] = useState(true)
  const [locationDesc, setLocationDesc] = useState("")
  const [supplierDesc, setSupplierDesc] = useState("")

  const [supSearchDisable, setSupSearchDisable] = useState(false)
  const [locSearchDisable, setLocSearchDisable] = useState(false)
  //*** End User input related states */
  //*** User input related Details level */
  const [dbSellingAmount, SetdbSellingAmount] = useState("0.0")
  const [dbGrossAmount, SetdbGrossAmount] = useState("0.0")
  const [dbDiscountPer, SetdbDiscountPer] = useState("0.0")
  const [dbItexAmount, SetdbItexAmount] = useState("0.0")
  const [dbETaxAmount, SetdbETaxAmount] = useState("0.0")
  const [dbAddAmount, SetdbAddAmount] = useState("0.0")
  const [dbDedAmount, SetdbDedAmount] = useState("0.0")
  const [dbNetAmount, SetdbNetAmount] = useState("0.0")
  const [TotalBookQty, setTotalBookQty] = useState("0.0")
  const [TotalCostValue, setTotalCostValue] = useState("0.0")
  const [TotalSellingValue, setTotalSellingValue] = useState("0.0")
  //*** User input related Details level */
  //*** User Activity related states*/
  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [AlertShow, setAlertShow] = useState(false)
  const [ShowTaxTable, setShowTaxTable] = useState(false)
  const [blDiasableGrid, SetblDiasableGrid] = useState(false)

  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [model_xlarge_sup, setmodel_xlarge_sup] = useState(false)
  const [model_xlarge_loc, setmodel_xlarge_loc] = useState(false)
  const [modal_xlargeMain, setmodal_xlargeMain] = useState(false)
  const [disabledDesc, setDisabledDesc] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [printEnable, setPrintEnable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [SupplierOpen, SetSupplieropen] = useState(false)
  const [menuCode, SetMenuCode] = useState("")

  //*** End User activity related staes */

  //*** useState to save table data */
  const [DataTables, SetDatatable] = useState([])
  const [DataTablesMain, SetDatatableMain] = useState([])
  const [strReason, setReason] = useState("Created")
  //*** End of useStates */

  const [disabled, setDisabled] = useState(false)
  const [GridRows, setGridRows] = useState([{
    id: 1,
    code: "",
    desc: "",
    Cost: 0.0,
    Selling: 0.0,
    StartBook: 0,
    EndBook: 0,
    NoOfBook: 0,
    CostValue: 0.0,
    SellingValue: 0.0,
    rate: 0.0
  }])

  const [voucherPORef, setVoucherPORef] = useState([])

  const [rowsTax, setTax] = useState([])
  const [SupplierTax, setSupplierTax] = useState([])

  function handleAddRowNested() {
    const modifiedRows = [...GridRows];

    const maxId = modifiedRows.reduce((max, row) => Math.max(max, row.id), 0);

    modifiedRows.push({
      id: maxId + 1,
      code: "",
      desc: "",
      Cost: 0.0,
      Selling: 0.0,
      StartBook: 0,
      EndBook: 0,
      NoOfBook: 0,
      CostValue: 0.0,
      SellingValue: 0.0,
      rate: 0.0
    });

    setGridRows(modifiedRows);
    BookChange();
    // handleAddRowTax();
  }


  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  const [helpUrl, setHelpUrl] = useState("")
  //*****Menu Rights End */
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL

  //**Get File Details */
  useEffect(async () => {
    const authToken = localStorage.getItem("authToken")
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]

    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)
    const ApiURL = window.Links.ApiURL


    var requestOptions = {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setPermissionReasonShow(result.data.strMenuReasonShow)
        SetMenuAccess(result.data.strMenuAccessRight)
        SetMenuCreate(result.data.strMenuCreateRight)
        SetMenuDelete(result.data.strMenuDeleteRight)
        SetMenuModify(result.data.strMenuModifyRight)
        SetMenuPrint(result.data.strMenuPrintRight)
        SetMenuProcess(result.data.strMenuProcessRight)
        SetMenuName(result.data.strMenuName)
        SetMenuCode(result.data.strMenuTag)
        setHelpUrl(result.data.strHelpUrl)
      }).catch(error =>
        console.log('error', error)
      );

  }, [])


  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])



  function handleRemoveRow(id, code) {
    var FilteredRows = GridRows.filter((row) => row.id !== id)

    if (FilteredRows.length == 0) {
      FilteredRows.push({
        id: 1,
        code: "",
        desc: "",
        Cost: 0.0,
        Selling: 0.0,
        StartBook: 0,
        EndBook: 0,
        NoOfBook: 0,
        CostValue: 0,
        SellingValue: 0,
        rate: 0
      })
    }

    var FilterTax = rowsTax.filter((row) => row.code != code)
    setGridRows(FilteredRows)
    setTax(FilterTax)

    BookChange(FilteredRows, FilterTax, 1)
  }

  function BookChange(FilteredArray = [], FilteredTax = [], id = 0, tax = []) {

    let NoOfBook = 0
    let TotCostValue = 0
    let TotSellingValue = 0
    let TaxIncTotal = 0;
    let TaxExTotal = 0;

    var itemArray = FilteredArray.length > 0 ? FilteredArray : GridRows

    itemArray.map((obj, index) => {
      NoOfBook = parseFloat(NoOfBook) + parseFloat(obj.NoOfBook)
      TotCostValue = parseFloat(TotCostValue) + parseFloat(obj.CostValue)
      TotSellingValue = parseFloat(TotSellingValue) + parseFloat(obj.SellingValue)
    })

    //tax calculation

    let taxArray = tax.length > 0 ? FilteredTax : rowsTax

    let newTaxArray = []

    itemArray.map((item, index) => {

      let itemArray = taxArray.filter(x => x.code == item.code)

      if (itemArray.length > 0) {

        itemArray.map((taxItem, index) => {
          let grossAmt = parseFloat(item.CostValue)
          let taxRate = parseFloat(taxItem.TaxRate)
          let taxAmount = 0

          if (taxItem.isInclude == 1) {
            taxAmount = (grossAmt * taxRate) / (100 + taxRate)
          } else {
            taxAmount = (grossAmt * taxRate) / 100
          }

          newTaxArray.push({
            id: index + 1,
            code: item.code,
            desc: item.desc,
            TaxCode: taxItem.TaxCode,
            grossAmt: grossAmt,
            TaxRate: taxRate,
            isInclude: taxItem.isInclude,
            TaxAmount: taxAmount,
          })
        })

      }

    })


    newTaxArray.map((obj, index) => {
      if (obj.isInclude == 1) {
        TaxIncTotal = parseFloat(TaxIncTotal) + parseFloat(obj.TaxAmount);
      } else {
        TaxExTotal = parseFloat(TaxExTotal) + parseFloat(obj.TaxAmount);
      }
    })

    if (newTaxArray.length > 0) {
      setShowTaxTable(true)
    } else {
      setShowTaxTable(false)
    }


    setTotalBookQty(parseFloat(NoOfBook))
    setTotalCostValue(parseFloat(TotCostValue).toFixed(2))
    SetdbGrossAmount(parseFloat(TotCostValue).toFixed(2))
    setTotalSellingValue(parseFloat(TotSellingValue).toFixed(2))


    SetdbItexAmount(parseFloat(TaxIncTotal).toFixed(2))
    SetdbETaxAmount(parseFloat(TaxExTotal).toFixed(2))

    var netAmount = parseFloat(TotCostValue) + parseFloat(TaxExTotal) + parseFloat(dbAddAmount) - parseFloat(dbDedAmount) + (parseFloat(TotCostValue) * parseFloat(dbDiscountPer) / 100)

    SetdbNetAmount(parseFloat(netAmount).toFixed(2))

    setTax(newTaxArray)

  }







  function handleAddRowTax(code, desc, txtCostValue, TotCostValue) {
    const authToken = localStorage.getItem("authToken")

    if (code != "") {
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}VoucherPO/searchTax/${code}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            const SupplierTax = responseData.data
            var newArray = []
            SupplierTax.map((item, index) => {
              newArray.push({
                id: index + 1,
                code: code,
                desc: desc,
                TaxCode: item.tax_Code,
                grossAmt: 0,
                TaxRate: item.tax_RAte,
                isInclude: item.tax_inclu,
                TaxAmount: 0,
              })
            })
            setSupplierTax(newArray)
          } else {
            //setdesc("")
          }
        })
    } else {
      //  setdesc("")
    }
  }

  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }


  function tox_xlarge_sup() {
    setmodel_xlarge_sup(!model_xlarge_sup)
    removeBodyCss()
  }

  function tox_xlarge_loc() {
    setmodel_xlarge_loc(!model_xlarge_loc)
    removeBodyCss()
  }

  function tog_xlargeMain() {
    setmodal_xlargeMain(!modal_xlargeMain)
    removeBodyCss()
  }


  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  //save button function
  const handlesave = async () => {
    // e.preventDefault()

    var VoucherPoDet = []

    GridRows.map((item, index) => {
      if (item.code != "") {
        VoucherPoDet = VoucherPoDet.concat(
          VoucherPoBuilder(
            item.code,
            item.Cost,
            item.Selling,
            item.StartBook,
            item.NoOfBook,
            item.EndBook,
            item.CostValue,
            item.SellingValue
          ))
      }
    })

    if (VoucherPoDet.filter(x => parseFloat(x.DET_VCBQTY) == 0).length > 0) {
      displayAlertMessage('danger', "Number of Book can not be zero !")
      return
    }

    if (strSupplier == "") {
      displayAlertMessage('danger', "Please Select a supplier !")
      return
    }
    if (strLocation == "") {
      displayAlertMessage('danger', "Please Select a Location")
      return
    }

    if (strRefNo == "") {
      displayAlertMessage('danger', "Please Select a Reference PO")
      return
    }


    if (!VoucherPoDet.length) {
      displayAlertMessage('danger', "Need to assign at least one Voucher group !")
      return
    }
    var VoucherPoTaxDet = []

    rowsTax.map((item, index) => {
      VoucherPoTaxDet.push(
        VoucherPoTaxBuilder(
          item.code,
          item.TaxCode,
          item.grossAmt,
          item.TaxRate,
          item.isInclude,
          item.TaxAmount
        )
      )
    })

    //loading alert show
    SetLoadingAlert(true)
    if (addNew == true) {
      SetLoadingAlerttitle("Saving...")
    } else {
      SetLoadingAlerttitle("Updating...")
    }


    let strResult = await setVoucherSave(
      strVoucherCode,
      strVoucherDate,
      LocationCode,
      LogCompanyCode,
      strSupplier,
      strLocation,
      strRemarks1,
      strRemarks2,
      strRefNo,
      strBatchNo,
      parseFloat(TotalSellingValue),
      parseFloat(dbGrossAmount),
      parseFloat(dbDiscountPer),
      parseFloat(dbItexAmount),
      parseFloat(dbETaxAmount),
      parseFloat(dbAddAmount),
      parseFloat(dbDedAmount),
      parseFloat(dbNetAmount),
      LogUserType,
      menuCode,
      LogCompanyCode,
      LocationCode,
      strReason,
      VoucherPoDet,
      VoucherPoTaxDet
    )

    SetLoadingAlert(false)
    if (strResult.status == "200") {
      strResult.json().then(responseData => {
        console.log(responseData.data)
        if (responseData.data == "Record Already Exsist!") {
          displayAlertMessage('danger', responseData.data)
        } else if (responseData.data == "Code Already Exsist!") {
          displayAlertMessage('danger', responseData.data)
        } else {
          handleNew()
          displayAlertMessage('success', responseData.data)
        }
      })
    } else if (strResult.status == "400") {
      strResult.json().then(responseData => {
        setAlertMsg(responseData.msg)

      })
      setAlertColor("danger")
      //setAlertMsg("Oops something went wrong !")
      setAlertShow(true)
    } else {
      handleNew()
    }
    setTimeout(() => {
      setAlertShow(false)
    }, 6000)
  }

  //Voucher Po table Array
  const VoucherPoBuilder = (
    code,
    Cost,
    Selling,
    StartBook,
    NoOfBook,
    EndBook,
    CostValue,
    SellingValue
  ) => {
    return {
      DET_TYPE: "VPO",
      DET_RUNNO: strVoucherCode,
      DET_SETUPLOC: "001",
      DET_VCCAT: code,
      DET_SPRICE: parseFloat(Selling),
      DET_CPRICE: parseFloat(Cost),
      DET_VCBSTART: parseFloat(StartBook),
      DET_VCBQTY: parseFloat(NoOfBook),
      DET_VCBEND: parseFloat(EndBook),
      DET_SVALUE: parseFloat(SellingValue),
      DET_CVALUE: parseFloat(CostValue),
    }
  }
  //Voucher Po table Array
  const VoucherPoTaxBuilder = (
    VGroupCode,
    Tax,
    GrossAmt,
    TaxRate,
    IsInclude,
    TaxAmount
  ) => {
    return {
      DET_VCCAT: VGroupCode,
      TDET_TAXCODE: Tax,
      TDET_GROAMT: parseFloat(GrossAmt),
      TDET_TAXRATE: parseFloat(TaxRate),
      TDET_TAXINC: IsInclude,
      TDET_TAXAMT: parseFloat(TaxAmount),

    }
  }


  //*** Get user selected row details */
  const GetSelectRow = (e, row, isSelect, rowIndex) => {
    SetRefNo(row.HED_RUNNO)
    ValueSetter(row.HED_RUNNO)
    setmodal_xlarge(!modal_xlarge)
  }

  const GetSelectRowSup = (e, row, isSelect, rowIndex) => {
    SetSupplier(row.SM_CODE)
    getSupplier(row.SM_CODE)
    setmodel_xlarge_sup(!model_xlarge_sup)

  }

  const GetSelectRowLoc = (e, row, isSelect, rowIndex) => {
    SetLocation(row.LOC_CODE)
    getLocation(row.LOC_CODE)
    setmodel_xlarge_loc(!model_xlarge_loc)

  }


  const GetSelectRowMain = (e, row, isSelect, rowIndex) => {
    SetCode(row.HED_RUNNO)
    ValueSetterGRN(row.HED_RUNNO)
    setmodal_xlargeMain(!modal_xlargeMain)

  }
  //*** End of getSelectedRow function */

  //edit button function
  const handleEdit = e => {
    setDisabledDesc(false)
    setDisabledCode(true)
    setSaveEnable(true)
  }

  //new button function
  const handleNew = e => {
    ClearItem()
    setAlertMsg(false)
    setSaveEnable(true)
    setAlertShow(false)
  }

  //clear fields function
  const ClearItem = () => {
    let today = new Date()
    let date = today.toISOString().split("T")[0]
    SetCode("") // Set Code
    SetVoucherDate(date)
    SetSupplier("")
    setSupplierDesc("")
    setLocSearchDisable(false)
    setSupSearchDisable(false)
    SetLocation("")
    setLocationDesc("")
    SetRemarks1("")
    SetRemarks2("")
    SetRefNo("")
    SetBatchNo("")
    SetdbSellingAmount("0.0")
    SetdbGrossAmount("0.0")
    SetdbDiscountPer("0.0")
    SetdbItexAmount("0.0")
    SetdbETaxAmount("0.0")
    SetdbAddAmount("0.0")
    SetdbDedAmount("0.0")
    SetdbNetAmount("0.0")
    setTotalBookQty("0.0")
    setTotalCostValue("0.0")
    setTotalSellingValue("0.0")

    setGridRows([])
    setTax([])
    setSupplierTax([])
    setVoucherPORef([])
    SetmainSearchEnable(false)
    SetblDiasableGrid(false)
    setShowTaxTable(false)
    SetVoucherCodeEnable(false)
    SetVoucherDateEnable(false)
    SetSupplierEnable(false)
    SetLocationEnable(false)
    SetRemarks1Enable(false)
    SetRemarks2Enable(false)
    SetRefNoEnable(false)
    SetBatchNoEnable(false)
    SetDisableRefNo(false)
    setSaveEnable(true)
    setCrEnable(false)
    setPrintEnable(false)
    setTimeout(() => {
      setGridRows([{
        id: 1,
        code: "",
        desc: "",
        Cost: 0.0,
        Selling: 0.0,
        StartBook: 0,
        EndBook: 0,
        NoOfBook: 0,
        CostValue: 0.0,
        SellingValue: 0.0,
        rate: 0.0
      }])
    }, 1)
  }
  // Set values to variables(Data Recall main method)
  const ValueSetter = async code => {

    const Response = await getVoucherPendingPOHeader(code)

    if (!Response.success) {
      SetRefNo("")
      displayAlertMessage('danger', "Voucher PO not found !")
      return
    }


    Response.data.map(dr => {
      let modifiedRows = []
      let modifiedRowsTax = []
      setCrEnable(true)
      setSaveEnable(true)
      SetVoucherDate(dr.dtTxnDate)
      SetSupplier(dr.strSupCode)
      getSupplier(dr.strSupCode)
      SetLocation(dr.strLocCode)
      getLocation(dr.strLocCode)
      SetRemarks1(dr.strRef1)
      SetRemarks2(dr.strRef2)
      SetdbSellingAmount(parseFloat(dr.dbSellingAmount).toFixed(2))
      SetdbDiscountPer(parseFloat(dr.dbDiscountPer).toFixed(2))
      SetdbAddAmount(parseFloat(dr.dbAddAmount).toFixed(2))
      SetdbDedAmount(parseFloat(dr.dbDedAmount).toFixed(2))
      SetDisableRefNo(true)
      SetmainSearchEnable(true)
      SetBatchNo(dr.strBatchNo)
      SetBatchNoEnable(true)

      SetblDiasableGrid(false)
      SetVoucherCodeEnable(true)
      SetVoucherDateEnable(true)
      SetSupplierEnable(true)
      SetLocationEnable(true)
      SetRemarks1Enable(true)
      SetRemarks2Enable(true)

      let TotNoOfBook = 0;
      let TotCostValue = 0;
      let TotSellingValue = 0;
      dr.vcpodetails.map(dr => {
        TotNoOfBook = parseFloat(TotNoOfBook) + parseFloat(dr.deT_VCBQTY);
        TotCostValue = parseFloat(TotCostValue) + parseFloat(dr.deT_CVALUE);
        TotSellingValue = parseFloat(TotSellingValue) + parseFloat(dr.deT_SVALUE);
      })
      setTotalBookQty(TotNoOfBook)
      setTotalCostValue(parseFloat(TotCostValue).toFixed(2))
      setTotalSellingValue(parseFloat(TotSellingValue).toFixed(2))


      dr.vcpodetails.map(dr => {
        modifiedRows.push({
          id: modifiedRows.length + 1,
          code: dr.deT_VCCAT,
          desc: dr.deT_VCCATNAME,
          Cost: dr.deT_CPRICE,
          Selling: parseFloat(dr.deT_SPRICE).toFixed(2),
          StartBook: dr.deT_VCBSTART,
          EndBook: dr.deT_VCBEND,
          NoOfBook: dr.deT_VCBQTY,
          CostValue: parseFloat(dr.deT_CVALUE).toFixed(2),
          SellingValue: parseFloat(parseFloat(dr.deT_SPRICE) * parseFloat(dr.deT_BOOKQTY) * parseFloat(dr.deT_VCBQTY)).toFixed(2),
          rate: dr.deT_BOOKQTY
        })
      })
      setGridRows(modifiedRows)

      //clone modifiedRows 
      var newArray = modifiedRows.map((item, index) => {
        return { ...item, ref: index + 1 }
      })


      setVoucherPORef(newArray)


      dr.vcpotaxdetails.map(dr => {
        setShowTaxTable(true)
        modifiedRowsTax.push({
          id: modifiedRowsTax.length + 1,
          code: dr.tdeT_VCCAT,
          desc: dr.tdeT_VCCATDESC,
          TaxCode: dr.tdeT_TAXCODE,
          grossAmt: parseFloat(dr.tdeT_GROAMT).toFixed(2),
          TaxRate: dr.tdeT_TAXRATE,
          isInclude: dr.tdeT_TAXINC,
          TaxAmount: parseFloat(dr.tdeT_TAXAMT).toFixed(2),

        })
      })
      setTax(modifiedRowsTax)

      setTimeout(() => {
        BookChange(modifiedRows, modifiedRowsTax, 1, modifiedRowsTax)
      }, 500);


    })

  }

  // Set values to variables(Data Recall main method)
  const ValueSetterGRN = async code => {

    if (code == "") return

    if (validateSpecialCharacters(code) == true) {
      SetCode("")
      return
    }
    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")
    let { success, data } = await getVoucherGRNHeader(code, LocationCode)
    SetLoadingAlert(false)

    if (success) {
      data.map(dr => {
        setGridRows([])
        setTax([])
        let modifiedRows = []
        let modifiedRowsTax = []
        setCrEnable(true)
        setSaveEnable(false)
        SetVoucherDate(dr.dtTxnDate)
        SetSupplier(dr.strSupCode)
        getSupplier(dr.strSupCode)
        SetLocation(dr.strLocCode)
        getLocation(dr.strLocCode)
        SetRemarks1(dr.strRef1)
        SetRemarks2(dr.strRef2)
        SetRefNo(dr.strRefNo)
        setSupSearchDisable(true)
        setLocSearchDisable(true)
        SetdbSellingAmount(parseFloat(dr.dbSellingAmount).toFixed(2))
        SetdbGrossAmount(parseFloat(dr.dbGrossAmount).toFixed(2))
        SetdbDiscountPer(parseFloat(dr.dbDiscountPer).toFixed(2))
        SetdbItexAmount(parseFloat(dr.dbItexAmount).toFixed(2))
        SetdbETaxAmount(parseFloat(dr.dbETaxAmount).toFixed(2))
        SetdbAddAmount(parseFloat(dr.dbAddAmount).toFixed(2))
        SetdbDedAmount(parseFloat(dr.dbDedAmount).toFixed(2))
        SetdbNetAmount(parseFloat(dr.dbNetAmount).toFixed(2))
        setCrBy(dr.createdBy)
        //setMdBy(dr.modifiedDate)
        setCrDate(dr.createdDate)
        // setMdDate(dr.modifiedBy)
        SetBatchNo(dr.strBatchNo)
        SetmainSearchEnable(true)
        SetblDiasableGrid(true)

        SetVoucherCodeEnable(true)
        SetVoucherDateEnable(true)
        SetSupplierEnable(true)
        SetLocationEnable(true)
        SetRemarks1Enable(true)
        SetRemarks2Enable(true)
        SetRefNoEnable(true)
        SetBatchNoEnable(true)
        SetDisableRefNo(true)

        let TotNoOfBook = 0;
        let TotCostValue = 0;
        let TotSellingValue = 0;
        dr.vcgrndetails.map(dr => {
          TotNoOfBook = parseFloat(TotNoOfBook) + parseFloat(dr.deT_VCBQTY);
          TotCostValue = parseFloat(TotCostValue) + parseFloat(dr.deT_CVALUE);
          TotSellingValue = parseFloat(TotSellingValue) + parseFloat(dr.deT_SVALUE);
        })
        setTotalBookQty(TotNoOfBook)
        setTotalCostValue(TotCostValue)
        setTotalSellingValue(TotSellingValue)


        dr.vcgrndetails.map(dr => {
          modifiedRows.push({
            id: modifiedRows.length + 1,
            code: dr.deT_VCCAT,
            desc: dr.deT_VCCATNAME,
            Cost: dr.deT_CPRICE,
            Selling: dr.deT_SPRICE,
            StartBook: dr.deT_VCBSTART,
            EndBook: dr.deT_VCBEND,
            NoOfBook: dr.deT_VCBQTY,
            CostValue: dr.deT_CVALUE,
            SellingValue: dr.deT_SVALUE,
          })
        })
        setGridRows(modifiedRows)

        dr.vcgrntaxdetails.map(dr => {

          modifiedRowsTax.push({
            id: modifiedRowsTax.length + 1,
            code: dr.tdeT_VCCAT,
            desc: dr.tdeT_VCCATDESC,
            TaxCode: dr.tdeT_TAXCODE,
            grossAmt: dr.tdeT_GROAMT,
            TaxRate: dr.tdeT_TAXRATE,
            isInclude: dr.tdeT_TAXINC,
            TaxAmount: dr.tdeT_TAXAMT,

          })
        })

        const showTax = modifiedRowsTax.length > 0 ? true : false
        setShowTaxTable(showTax)

        setTax(modifiedRowsTax)
        setPrintEnable(true)

        //BookChange(modifiedRows, modifiedRowsTax, 1)
      })
    } else {
      displayAlertMessage('success', 'Record Not Found !')
    }

  }

  //default sorted method
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //default sorted method
  const defaultSortedMain = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  function getSupplier(supCode) {

    if (supCode == "" || supCode == undefined) {
      SetSupplier("")
      setSupplierDesc("")
      return
    }

    fetch(`${ApiURL}Supplier/search/${supCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          const dt = responseData.data[0]
          setSupplierDesc(dt.name)
          setSupSearchDisable(true)
          handleAddRowTax(dt.code, dt.name)
        } else {
          SetSupplier("")
          setSupplierDesc("")
          displayAlertMessage('danger', "Invalid Supplier Code")
          return
        }
      }).catch((error) => {
      })
  }

  function getLocation(locCode) {
    if (locCode == "" || locCode == undefined) {
      SetLocation("")
      setLocationDesc("")
      return
    }
    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };
    fetch(`${ApiURL}Locations/SearchCode/${locCode}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        const dt = result.data[0];
        if (result.success == true) {
          setLocationDesc(dt.name)
          setLocSearchDisable(true)
        }
        else {
          SetLocation("")
          setLocationDesc("")
          displayAlertMessage('danger', "Invalid Location Code")
          return
        }
      })
      .catch(error => console.log('error', error));
  }

  //**Permission Check */
  const permission = (operation) => {

    const permissiondata = {
      "strUsername": permissionName,
      "strPassword": permissionPassword,
      "strLocation": LocationCode,
      "strMenuCode": menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {
            console.log(responseData.data)
            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")
                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")
                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        setDisabledCode(false)
        clearPermissionInputs()
        displayAlertMessage('danger', "Oops something went wrong !")

      } else if (Response.status == "403") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }


  async function handlePrint(option) {

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")

    const authToken = localStorage.getItem("authToken")
    const ReportURL = window.Links.ReportURL
    await fetch(`${ReportURL}api/VoucherGRN/report/${LogUserType}/${strVoucherCode}/${strLocation}/${option == "PDF" ? 1 : 0}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (option == "PDF") {
            {
              const msg = responseData.msg
              window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
            }
          }
          if (option == "XCEL") {
            {
              const msg = responseData.msg
              window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
            }
          }
        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
        SetLoadingAlert(false)
      })
  }

  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setAlertShow(true)

    setTimeout(() => {
      setAlertShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }

  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
    console.log(response)
  }


  const validateSpecialCharacters = (str) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharRegex.test(str);
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumb
            title={parentName}
            breadcrumbItem={menuName}
          ></Breadcrumb>
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {

                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)

                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)

                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                window.location.href = "/";
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 6) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)

                } else {
                  setPermissionName("")
                  setPermissionNameDisable(false)
                  setPermissionAlertShow(true)
                }
              }

            }}
            onCancel={() => {
              setsweetAlertShow(false)
              clearPermissionInputs()
            }}
            SupplierOpen={SupplierOpen}
            SetSupplieropen={() => {
              SetSupplieropen(!SupplierOpen)
            }}
          />
          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}
            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, true, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={strReason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 5) {
                permission("Delete")
              } else if (AlertConfirmOption == 6) {
                permission("Print")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={false}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={printEnable}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to print ?");
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={false}
                    deleteClick={() => {
                      alert("Delete")
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <Row>
                    <VoucherGRNContent
                      Gen_DataSearch={async () => {
                        // let data = await getVoucherGRNSearch(LocationCode)

                        // let i = 1
                        // data.map(r => {
                        //   searchDataMain = searchDataMain.concat(
                        //     TableDataBuilderMain(i, r)
                        //   )
                        //   i++
                        // })
                        // console.log(searchDataMain)
                        // SetDatatableMain(searchDataMain)
                        tog_xlargeMain()
                      }}
                      DataTablesMain={DataTablesMain}
                      Hed_CodeSearchOpenMain={modal_xlargeMain}
                      Hed_CodeSearchTriggerMain={tog_xlargeMain}
                      SearchDataTablesMain={DataTablesMain}
                      SearchDefaultSortedMain={defaultSortedMain}
                      SearchModelOpenMain={modal_xlargeMain}
                      SearchModelTriggerMain={tog_xlargeMain}
                      SearchGetSelectRowMain={GetSelectRowMain}

                      DataTables={DataTables}
                      Hed_CodeSearchOpen={modal_xlarge}
                      Hed_CodeSearchTrigger={tog_xlarge}
                      AlertColor={AlertColor}
                      AlertMsg={AlertMsg}
                      show={AlertShow}
                      Gen_Code={strVoucherCode}
                      Gen_Code_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          13,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetCode(valCode)
                      }}
                      Gen_Code_onBlur={e => {
                        ValueSetterGRN(e.target.value)
                      }}
                      Gen_Code_Enabled={blVoucherCodeEnable}
                      Gen_Supplier={strSupplier}
                      Gen_Supplier_Enabled={blSupplierEnable}
                      Gen_Location={strLocation}
                      Gen_Location_Enabled={blLocationEnable}
                      Gen_TxnDate={strVoucherDate}
                      Gen_TxnDate_OnChange={e => {
                        SetVoucherDate(e.target.value)
                      }}
                      Gen_TxnDate_Enabled={blVoucherDateEnable}
                      Gen_Remark1={strRemarks1}
                      Gen_Remark1_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRemarks1(valCode)
                      }}
                      Gen_BatchNo={strBatchNo}
                      Gen_BatchNo_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          15,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetBatchNo(valCode)
                      }}
                      Gen_BatchNo_Enabled={blBatchNoEnable}
                      Gen_Remark1_Enabled={blRemarks1Enable}
                      Gen_Remark2={strRemarks2}
                      Gen_Remark2_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRemarks2(valCode)
                      }}
                      Gen_Remark2_Enabled={blRemarks2Enable}
                      SearchDataTables={DataTables}
                      SearchDefaultSorted={defaultSorted}
                      SearchModelOpen={modal_xlarge}
                      SearchModelTrigger={tog_xlarge}
                      SearchGetSelectRow={GetSelectRow}
                      Gen_VoucherPOSearch={async () => {
                        tog_xlarge()
                      }}
                      Gen_VoucherPO={strRefNo}
                      Gen_VoucherPO_OnChange={e => {

                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRefNo(valCode)
                      }}
                      Gen_VoucherPO_onBlur={e => {
                        ValueSetter(e.target.value)
                      }}
                      Gen_VoucherPO_Enabled={blRefNoEnable}
                      Gen_mainSearchEnabled={blmainSearchEnable}
                      menuCode={menuCode}
                      LocationCode={LocationCode}
                      supplierDesc={supplierDesc}
                      locationDesc={locationDesc}
                      supplierOnblur={e => {
                        getSupplier(e.target.value)
                      }}
                      locationOnblur={e => {
                        getLocation(e.target.value)
                      }}
                      tox_xlarge_loc={tox_xlarge_loc}
                      tox_xlarge_sup={tox_xlarge_sup}
                      model_xlarge_loc={model_xlarge_loc}
                      model_xlarge_sup={model_xlarge_sup}
                      Gen_Location_OnChange={e => {
                        let val1 = Text(
                          e.target,
                          5,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetLocation(val1)
                      }}
                      Gen_Supplier_OnChange={e => {

                        let val1 = Text(
                          e.target,
                          10,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetSupplier(val1)
                      }}
                      GetSelectRowSup={GetSelectRowSup}
                      GetSelectRowLoc={GetSelectRowLoc}
                      supSearchDisable={supSearchDisable}
                      locSearchDisable={locSearchDisable}
                      disableRefNo={disableRefNo}
                    />
                  </Row>
                  <Row>
                    <VoucherGRNDetails
                      DataRow={GridRows}
                      RemoveRow={handleRemoveRow}
                      BookChange={BookChange}
                      AddRow={handleAddRowNested}
                      Disabled={disabled}
                      GrossAmount={dbGrossAmount}
                      SellingAmount={dbSellingAmount}
                      DiscountPer={dbDiscountPer}
                      DiscountPer_OnChange={e => {
                        let valDiscountPer = Numeric(e.target, 8, 2, false)
                        if (valDiscountPer == "") {
                          SetdbDiscountPer(0.0)
                        } else {
                          SetdbDiscountPer(valDiscountPer)
                        }
                      }}
                      DiscountPer_OnBlur={e => {
                        let val = DecimalValidation(e.target.value)
                        if (val <= 100) {
                          let NetAmount = (parseFloat(dbGrossAmount) + parseFloat(dbAddAmount) + parseFloat(dbETaxAmount)) - ((parseFloat(dbGrossAmount) * parseFloat(val)) / 100 + parseFloat(dbDedAmount))
                          SetdbNetAmount(parseFloat(NetAmount, 10).toFixed(2))
                          SetdbDiscountPer(val)
                        } else {
                          SetdbDiscountPer(0.0)
                        }
                      }}
                      texAmount={dbItexAmount}
                      texAmount_OnChange={e => {
                        SetdbItexAmount(dbItexAmount)
                      }}
                      ETaxAmount={dbETaxAmount}
                      ETaxAmount_OnChange={e => {
                        SetdbETaxAmount(dbETaxAmount)
                      }}
                      AddAmount={dbAddAmount}
                      AddAmount_OnChange={e => {
                        let valAddAmount = Numeric(e.target, 8, 2, false)
                        if (valAddAmount == "") {
                          SetdbAddAmount(0.0)
                        } else {
                          SetdbAddAmount(e.target.value)
                        }
                      }}
                      AddAmount_OnBlur={e => {
                        let val = DecimalValidation(e.target.value, 0, true, 2)
                        let NetAmount = (parseFloat(dbGrossAmount) + parseFloat(val) + parseFloat(dbETaxAmount)) - ((parseFloat(dbGrossAmount) * parseFloat(dbDiscountPer)) / 100 + parseFloat(dbDedAmount))
                        SetdbNetAmount(parseFloat(NetAmount, 10).toFixed(2))
                        SetdbAddAmount(val)

                      }}
                      DedAmount={dbDedAmount}
                      DedAmount_OnChange={e => {
                        let valDedAmount = Numeric(e.target, 8, 2, false)
                        if (valDedAmount == "") {
                          SetdbDedAmount(0.0)
                        } else {
                          SetdbDedAmount(e.target.value)
                        }
                      }}
                      DedAmount_OnBlur={e => {
                        let val = DecimalValidation(e.target.value, 0, true, 2)
                        let NetAmount = (parseFloat(dbGrossAmount) + parseFloat(dbAddAmount) + parseFloat(dbETaxAmount)) - ((parseFloat(dbGrossAmount) * parseFloat(dbDiscountPer)) / 100 + parseFloat(val))
                        SetdbNetAmount(parseFloat(NetAmount, 10).toFixed(2))
                        SetdbDedAmount(val)
                      }}
                      NetAmount={dbNetAmount}
                      TotalBookQty={TotalBookQty}
                      TotalCostValue={TotalCostValue}
                      TotalSellingValue={TotalSellingValue}
                      rowsTax={rowsTax}
                      SupplierCode={strSupplier}
                      ShowTaxTable={ShowTaxTable}
                      blDiasableGrid={blDiasableGrid}
                      menuCode={menuCode}
                      LocationCode={LocationCode}
                      setGridRows={setGridRows}
                      SupplierTax={SupplierTax}
                      setSupplierTax={setSupplierTax}
                      setTax={setTax}
                      voucherPORef={voucherPORef}
                      menuName={menuName}
                    />
                  </Row>

                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default VoucherGRN
